module.exports = __webpack_public_path__ + "img/744.6e061a5d.jpg";